<div class="modal-container">
  <app-icon class="modal-icon" [icon]="data.iconName" />
  <div class="modal-title">{{ data.title | translate }}</div>
  <div class="modal-text">{{ data.infoText | translate }}</div>
  <div class="modal-actions">
    <button (click)="close()">{{ data.action | translate }}</button>
  </div>
</div>
